import { Form, Input, Button, Upload, DatePicker, Typography, Select, Modal, message, Switch, Tooltip, Space, Image } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import React, { useState, useEffect, useRef } from 'react';
import moment from "moment";

import Api from "../../../api";
import {pagingParam} from "../../../utils/defaultValue";
import storage from '../../../utils/storage'
import {ModalConfirm} from '../../../utils/tool'
import SelfTable from "../../../components/SelfTable/index"

import './index.scss'

const { confirm } = Modal;
const { TextArea } = Input;

const TenantList = ({tableHight}) => {
    const [form] = Form.useForm();
    const [addForm] = Form.useForm();

    // 列表数据
    const [listData, setListData] = useState([]);

    // 当前正在操作的数据KEY
    const [editingKey, setEditingKey] = useState({});

    // 查询数据
    const [searchData, setSearchData] = useState({
        ...pagingParam
    });
    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0
    });

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [confirmLoading, setConfirmLoading] = useState(false);

    const [tableLoading, setTableLoading] = useState(false);

    const [operationData, setOperationData] = useState({});

    const [tenantPackageList, setTenantPackageList] = useState([]);

    const [tenanList, setTenantList] = useState([]);
    const [showTenanSelect, setShowTenanSelect] = useState(false);

    const [fileList, setFileList] = useState([])
    
    const [uploadFile, setUploadFile] = useState('');
    const [logoFileUrl, setLogoFileUrl] = useState('');
    const [logoNoTextFileUrl, setLogoNoTextFileUrl] = useState('');

    useEffect(() => {
        getTenanList();
        getSelectTenantPackage();
    }, []);

    useEffect(() => {
        getList();
    }, [searchData]);

    const getTenanList = async() =>{
        // 是否接入门户
        const res = await Api.Tenant.getisAccessPortal();
        if(res){
            setShowTenanSelect(res.data);
        }
        
        // 查询门户租户列表
        if(res && res.data){
            const res1 = await Api.Tenant.queryPortalTenant();
            setTenantList(res1.data);
        }
    }

    const getSelectTenantPackage = async() => { 
        const res = await Api.Tenant.selectTenantPackage();
        if(res&&res.code === 0){
            let _data = res.data;
            setTenantPackageList(_data);
        }
    }

    // 获取列表数据
    const getList = async() => {
        setTableLoading(true);
        const res = await Api.Tenant.getTenantList({data:searchData});
        setTableLoading(false);
        if(res&&res.code === 0){
            let _data = res.data;
            setListData(_data.records);
            setPagination({
                "pageIndex": _data.current,
                "pageSize": _data.size,
                "total":_data.total
            });
            setEditingKey('');
        }else{
            setListData([]);
        }
    }

    // 修改
    const edit = (record) => {
        setEditingKey(record);
        setIsModalOpen(true);
        addForm.setFieldsValue({
           ...record,
           expireTime: record.expireTime ? moment(record.expireTime):''
        });

        if(record.logoFileUrl){
            setLogoFileUrl({
                url: record.logoFileUrl,
                id: record.logoFileId
            });
        }
        
        if(record.logoNoTextFileUrl){
            setLogoNoTextFileUrl({
                url: record.logoNoTextFileUrl,
                id: record.logoNoTextFileId
            });
        }
    };

    // 同步套餐
    const syncTenantPackage = async(record) => { 
        ModalConfirm({
            title: `是否确认同步租户套餐租户编号为"${record.tenantId}"的数据项？`,
            onOk:async(resolve, reject)=> {
                try{
                    const res = await Api.Tenant.syncTenantPackage({data:{
                        tenantId: record.tenantId,
                        packageId: record.packageId
                    }});
                    resolve();
                    if(res && res.code === 0){
                        message.success("同步成功");
                    }
                }catch{}
            },
        })
    }

    // 新增
    const handleOk = async() => {
        try {
            const row = await addForm.validateFields();
            setConfirmLoading(true);

            row.logoFileId = logoFileUrl?.id || '';
            row.logoNoTextFileId = logoNoTextFileUrl?.id || '';
            // 修改
            if(editingKey){
                row.id = editingKey.id;
                modifyTenant(row);
            }else{
                addTenantApi(row);
            }
        } catch (errInfo) {
            console.log('验证失败:', errInfo);
            setConfirmLoading(false);
        }
    }

    // 调用新增接口
    const addTenantApi = async(row)=>{
        try{ 
            const res = await Api.Tenant.addTenant({data:row});
            setConfirmLoading(false);
            if(res&&res.code === 0){
                message.success("新增成功",2,()=>{
                    setFileList([]);
                    handleCancel();
                    getList();
                })
            }
        }catch{ 
            setConfirmLoading(false);
        }
    }

    // 调用修改接口
    const modifyTenant = async(row) => {
        try{ 
            const res = await Api.Tenant.updateTenant({data:row});
            setConfirmLoading(false);
            if(res&&res.code === 0){
                message.success("修改成功",2,()=>{
                    setIsModalOpen(false);
                    setFileList([]);
                    getList();
                })
            }
        }catch{ 
            setConfirmLoading(false);
        }
    }

    // 打开新增角色权限
    const addTenant = () => {
        setFileList([]);
        setConfirmLoading(false);
        setIsModalOpen(true);
    }

    //删除角色权限
    const deleteTenantModal = (record) => {
        ModalConfirm({
            title: `您确认要删除这条数据吗?`,
            onOk:async(resolve, reject)=> {
                try{
                    const res = await Api.Tenant.deleteTenant(record.id);
                    resolve();
                    if(res && res.code === 0){
                        let newSearchData = {...searchData}
                        newSearchData.pageIndex = 1;
                        setSearchData(newSearchData);
                    }
                }catch{}
            },
        })
    }

    // 关闭新增角色权限
    const handleCancel = () => {
        setEditingKey("");
        setLogoFileUrl('');
        setLogoNoTextFileUrl('');
        setIsModalOpen(false);
    }

    // 分页变化
    const paginationChange = (page, pageSize) => {
        let newSearchData = {...searchData}
        newSearchData.pageIndex = page;
        newSearchData.pageSize = pageSize;
        setSearchData(newSearchData);
    }

    const columns = [
        {
            title: '租户编号',
            dataIndex: 'tenantId',
            width: '170px',
            align:"center",
            editable: true,
        },
        {
            title: '联系人',
            dataIndex: 'contactUserName',
            width: '110px',
            align:"center",
            editable: true,
        },
        {
            title: '联系电话',
            dataIndex: 'contactPhone',
            width: '130px',
            align:"center",
            editable: true,
        },
        {
            title: '企业名称',
            dataIndex: 'companyName',
            width: '',
            align:"center",
            editable: true,
        },
        // {
        //     title: '社会信用代码',
        //     dataIndex: 'licenseNumber',
        //     width: '150px',
        //     align:"center",
        //     editable: true,
        // },
        {
            title: '过期时间',
            dataIndex: 'expireTime',
            width: '150px',
            align:"center",
            editable: true,
        },
        {
            title: 'logo(带文字)',
            dataIndex: 'logoFileUrl',
            width: '150px',
            editable: true,
            changeType:"upload",
            align:"center",
            render:(val,record)=>{
                return val ? <Image
                    width={60}
                    preview={false}
                    src={val}
                /> : ''
            }
        },
        {
            title: 'logo',
            dataIndex: 'logoNoTextFileUrl',
            width: '150px',
            editable: true,
            changeType:"upload",
            align:"center",
            render:(val,record)=>{
                return val ? <Image
                    width={60}
                    preview={false}
                    src={val}
                /> : ''
            }
        },
        {
            title: '租户状态',
            dataIndex: 'status',
            width: '120px',
            align:"center",
            render: (_, record) => (
            <>
                <Switch
                    size="small"
                    checked={record.status == 0}
                    onChange={() => onChangeStatus(record)}
                    style={{'marginTop': '-3px',marginRight: 5}}
                />
                {record.status == 0 ? "启用" : "禁用"}
            </>
            ),
        },
        {
            title: '操作',
            width: '160px',
            align:"center",
            dataIndex: 'operation',
            render: (_, record) => {
                if(record.tenantId == '1'){
                    return null;
                }
                return(<Space>
                    <Typography.Link onClick={() => edit(record)}>
                        调整
                    </Typography.Link>
                    <Tooltip placement="top" title="同步套餐">
                        <Typography.Link onClick={() => syncTenantPackage(record)}>
                            同步
                        </Typography.Link>
                    </Tooltip>
                    <Typography.Link type="danger" onClick={()=>{deleteTenantModal(record)}}>
                        删除
                    </Typography.Link>
            </Space>)
            },
        },
    ];

    const onChangeStatus = async (record) => {
        let res = await Api.Tenant.changeTenantStatus({ data: {
            id:record.id,
            tenantId:record.tenantId,
            status: record.status == 0 ? 1 : 0
        } });
        if (res && res.data) {
          let newSearchData = {...searchData}
            newSearchData.pageIndex = 1;
            setSearchData(newSearchData);
          message.success("操作成功");
        }
    };

    const searchChange = (value, type) => {
        let newOperationData = {...operationData};
        newOperationData[type] = value;
        setOperationData(newOperationData)
    }

    const onResetting = () => {
        setOperationData({});
        setSearchData({
            ...pagingParam,
        })
    }

    const onSearch = () => {
        let newSearchData = {
            ...searchData,
            ...operationData,
            pageNum:1
        }
        setSearchData(newSearchData);
    }

    const onChange = (value, dateString) => {
        console.log('Selected Time: ', value);
        console.log('Formatted Selected Time: ', dateString);
    };
    const onOk = (value) => {
        console.log('onOk: ', value);
    };

    const tenanChange = (value,options) => {
        console.log('tenanChange: ', value,options);

        let newObj = {}
        for (const key in options) {
            if(options[key]){
                newObj[key] = options[key]
            }
        }
        addForm.setFieldsValue({
           ...newObj,
        //    expireTime: record.expireTime ? moment(record.expireTime):''
        });
    };

    // 上传图片获取id
    const uploadImgs = async(row,type) => {

        if(uploadFile.name){
            const formData = new FormData();
            formData.append("file",uploadFile);

            const res = await Api.Common.uploadFile({
                data:formData,
            });
            if(res&&res.code === 0){

                if(type === 'add'){
                    addTenantApi(row,res.data.id)
                }else{
                    modifyTenant(row,res.data.id)
                }
            }else{
                setConfirmLoading(false);
            }
        }else{
            if(type === 'add'){
                addTenantApi(row)
            }else{
                modifyTenant(row)
            }
        }


    }

    // 获取上传的图片
    const handleChange = async (file,type) => {
        // setFileList(newFileList);
        // setUploadFile(file);
        // 
        console.log('handleChange: ', file);
        const formData = new FormData();
        formData.append("file",file.file);

        const res = await Api.Common.uploadFile({
            data:formData,
        });
        if(res&&res.code === 0){
            if(type === 'logoFileId'){
                setLogoFileUrl(res.data)
            }else if(type === 'logoNoTextFileId'){
                setLogoNoTextFileUrl(res.data)
            }
        }
    };

    const uploadImg = (file, fileList) => {
        return false;
    };

    // 上传按钮
    const uploadButton = (
        <div>
          <PlusOutlined />
          <div
            style={{
              marginTop: 8,
            }}
          >
            上传图标
          </div>
        </div>
    );

    return (
        <div className="tenantListFrame">
            <div className="title">租户管理</div>
            <div className="operation">
                <div className="operationLeft">
                    <div className="operationItem">
                        <span className="inputTitle">租户编号：</span>
                        <Input 
                            placeholder="输入租户编号" 
                            value={operationData.tenantId} 
                            onChange={(e)=>{
                                searchChange(e.target.value,"tenantId")
                            }}
                            allowClear={true}
                        />
                    </div>
                    <div className="operationItem">
                        <span className="inputTitle">联系人：</span>
                        <Input 
                            placeholder="输入联系人" 
                            value={operationData.contactUserName} 
                            onChange={(e)=>{
                                searchChange(e.target.value,"contactUserName")
                            }}
                            allowClear={true}
                        />
                    </div>
                    <div className="operationItem">
                        <span className="inputTitle">联系电话：</span>
                        <Input 
                            placeholder="输入联系电话" 
                            value={operationData.contactPhone} 
                            onChange={(e)=>{
                                searchChange(e.target.value,"contactPhone")
                            }}
                            allowClear={true}
                        />
                    </div>
                    <div className="operationItem">
                        <span className="inputTitle">企业名称：</span>
                        <Input 
                            placeholder="输入企业名称" 
                            value={operationData.companyName} 
                            onChange={(e)=>{
                                searchChange(e.target.value,"companyName")
                            }}
                            allowClear={true}
                        />
                    </div>
                    <Space size={"middle"}>
                        <Button type="primary" onClick={onSearch}>搜索</Button>
                        <Button onClick={onResetting}>重置</Button>
                    </Space>
                </div>

                <Space size={"large"}>
                    <Button type="primary" onClick={addTenant}>新增租户</Button>
                </Space>
            </div>
            <div className="table">
                <Form form={form} component={false}>
                    <SelfTable
                        dataSource={listData}
                        columns={columns}
                        pagination={{
                            ...pagination,
                            onChange: paginationChange,
                        }}
                        loading={tableLoading}
                    />
                </Form>
            </div>

            <Modal
                title="新增租户"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                maskClosable={false}
                destroyOnClose={true}
                confirmLoading={confirmLoading}
            >
                <Form
                    form={addForm}
                    component={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 14 }}
                    preserve={false}
                >
                    <Form.Item
                        key={'logoFileId'}
                        label={'logo(带文字)'}
                        name={'logoFileId'}
                    >
                        <Upload
                            // accept="image/png, image/jpeg, image/svg+xml"
                            listType="picture-card"
                            maxCount={1}
                            // showUploadList={{
                            //     showPreviewIcon:false
                            // }}
                            showUploadList={false}
                            // fileList={fileList.length > 0 ? fileList: []}
                            onChange={(file)=>handleChange(file,"logoFileId")}
                            beforeUpload={uploadImg}
                            accept={"image/*"}
                        >
                            {logoFileUrl?<img src={logoFileUrl.url} alt="" style={{width:100}}/>:uploadButton}
                        </Upload>
                    </Form.Item>
                    <Form.Item
                        key={'logoNoTextFileId'}
                        label={'logo'}
                        name={'logoNoTextFileId'}
                    >
                        <Upload
                            // accept="image/png, image/jpeg, image/svg+xml"
                            listType="picture-card"
                            maxCount={1}
                            showUploadList={false}
                            // showUploadList={{
                            //     showPreviewIcon:false
                            // }}
                            // fileList={fileList.length > 0 ? fileList: []}
                            onChange={(file)=>handleChange(file,"logoNoTextFileId")}
                            beforeUpload={uploadImg}
                            accept={"image/*"}
                        >
                            {logoNoTextFileUrl?<img src={logoNoTextFileUrl.url} alt="" style={{width:100,height:100}}/>:uploadButton}
                        </Upload>
                    </Form.Item>

                    {showTenanSelect&&<Form.Item
                        key={'tenantId'}
                        label={'租户'}
                        name={'tenantId'}
                        rules={[{ required: true, message: `请选择租户!` }]}
                    >
                        <Select
                            disabled={editingKey&&editingKey.id}
                            allowClear={true}
                            fieldNames={{ value: 'tenantId', label: 'companyName' }}
                            options={tenanList}
                            onChange={(value,options)=>tenanChange(value,options)}
                        />
                    </Form.Item>}
                    <Form.Item
                        key={'companyName'}
                        label={'企业名称'}
                        name={'companyName'}
                        rules={[{ required: true, message: `请输入企业名称!` }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        key={'contactUserName'}
                        label={'联系人'}
                        name={'contactUserName'}
                        rules={[{ required: true, message: `请输入联系人!` }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        key={'contactPhone'}
                        label={'联系电话'}
                        name={'contactPhone'}
                        rules={[{ required: true, message: `请输入联系电话!` }]}
                    >
                        <Input />
                    </Form.Item>
                    {editingKey&&editingKey.id?null:<Form.Item
                        key={'username'}
                        label={'用户名'}
                        name={'username'}
                        rules={[{ required: true, message: `请输入用户名!` }]}
                    >
                        <Input />
                    </Form.Item>}
                    
                    {editingKey&&editingKey.id?null:<Form.Item
                        key={'password'}
                        label={'用户密码'}
                        name={'password'}
                        rules={[{ required: true, message: `请输入系统用户密码!` }]}
                    >
                        <Input />
                    </Form.Item>}

                    <Form.Item
                        key={'packageId'}
                        label={'租户套餐'}
                        name={'packageId'}
                        rules={[{ required: true, message: `请选择租户套餐!` }]}
                    >
                        <Select
                            disabled={editingKey&&editingKey.id}
                            allowClear={true}
                            fieldNames={{ value: 'packageId', label: 'packageName' }}
                            options={tenantPackageList}
                        />
                    </Form.Item>
                    <Form.Item
                        key={'expireTime'}
                        label={'过期时间'}
                        name={'expireTime'}
                    >
                        <DatePicker showTime onChange={onChange} onOk={onOk} />
                    </Form.Item>
                    <Form.Item
                        key={'accountCount'}
                        label={'用户数量'}
                        name={'accountCount'}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        key={'address'}
                        label={'企业地址'}
                        name={'address'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        key={'licenseNumber'}
                        label={'企业代码'}
                        name={'licenseNumber'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        key={'intro'}
                        label={'企业简介'}
                        name={'intro'}
                    >
                        <TextArea />
                    </Form.Item>
                    
                    <Form.Item
                        key={'remark'}
                        label={'备注'}
                        name={'remark'}
                    >
                        <TextArea />
                    </Form.Item>
                    
                </Form>
            </Modal>
        </div>
    );
};
export default TenantList;
